import Block from "base/Block";
class FeedbackForm extends Block {
	static get blockName() {
		return 'b-feedback-form';
	}

	onInit() {
		
	}
}

Block.register(FeedbackForm);

export default FeedbackForm;